<template>
    <div class='alarm_list'>
       <div class='title'>
           <span class="left-arrow"></span>
           <span class="title-info">报警信息列表</span>
           <span class="right-arrow"></span>
       </div>
       <div class="alarm-wrapper">
            <div class="left-info">
               <span>{{noAnswerNum||0}}/{{alarmTotalNum||0}}</span>
               <!--<span>18/20</span>-->
               <!--<span></span> -->
            </div>

            <div class="list-box">
                <el-carousel arrow="never" :autoplay="false" indicator-position="none" ref="carousel" v-if='table_data.length>0'>
                    <el-carousel-item v-for="(item,index) in table_data" :name="activeIndex" :key="index">
                        <div v-for='(_item,_index) in item' :key='_index' style="cursor:pointer" :class="['list-item',{'item-alarm':_item.alarmStatus==='待处理'}]" @click='alarm_detail(_item)'>
                            <!-- <p> -->
                                <span class='address'>{{_item.deviceName}}</span>
                            <!-- </p> -->
                            <!-- <p> -->

                                <span class='time'>{{_item.time}}</span>
                            <!-- </p> -->
                            <!-- <p> -->

                                <span class='type'>{{_item.alarmName}}</span>
                            <!-- </p> -->
                            <!-- <p> -->
                                <span class='opt'>{{_item.status}}</span>
                            <!-- </p> -->
                        </div>
                    </el-carousel-item>
                </el-carousel>
                <div class='tip' v-else>设备暂无报警信息</div>
            </div>

           <div class="right-info">
               <span class="left-slide-arrow" @click="leftSwitchEvent"></span>
               <span class="right-slide-arrow" @click="rightSwitchEvent"></span>
           </div>
       </div>
      <dialogItem :show-dialog="showDialog" @closeDialog='closeDialog' :dialogData='detail' @close_alarm='close_alarm'></dialogItem>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
import dataUrl from '../../libs/js/interfaceAddress.js';
import listCarousel from './alarm/listCarousel';
import dialogItem from '../../components/dialog/dialogs'
// import dialogItem from '../../components/dialog'
export default {
    data(){
        return{
            activeIndex:"0",
            swiperOption: {
                direction: 'horizontal',
            },
            //报警列表信息
            alarmList:[],
            alarmTotalNum:0,
            noAnswerNum:0,
            table_data:[],

            //弹出框
            showDialog:false,
            dialogData:{},

            //获取详情的参数
            params:{},
            detail:{
                infodata:{},
                alarminfo:{},
                right_chars_data:{},
                left_chars_data:{}
            },
            loading: null,
        }
    },
    mounted(){
        this.getList();
        this.$bus.$off('get-alarmList-bus').$on('get-alarmList-bus',this.getList);
        this.$bus.$off('alarm-box-detail').$on('alarm-box-detail',this.alarm_box_detail);


    },
    computed: {

    },
    beforeDestroy(){
        this.$bus.$off('get-alarmList-bus',this.getList);
        this.$bus.$off('alarm-box-detail',this.alarm_box_detail);

    },
    methods:{
        ...mapMutations(['set_todayAlarmNum']),
        getList(){
            this.alarmTotalNum =0;
            this.noAnswerNum =0;
             console.log("报警列表shijiangetList");
            this.$http.get(dataUrl.interfaceAddress.alarmList, {}).then(res => {
                 console.log("报警列表shijian",res.data.body);
                if(res.data.body){
                    this.alarmList = [];
                    this.table_data = [];
                    let list = res.data.body;
                    if(JSON.stringify(list) === "{}"){
                        this.set_todayAlarmNum(0);
                        return
                    }
                    if(list.alarmList&&list.alarmList.length>0){
                        this.alarmList = list.alarmList
                    }
                    this.alarmTotalNum = list.alarmTotalNum;
                    this.noAnswerNum =list.noAnswerNum;
                    this.set_todayAlarmNum(list.todayAlarmNum);
                    let arr = [];
                    let len = this.alarmList.length;
                    this.alarmList.forEach((item, index)=>{
                        let _index = index + 1;
                        arr.push(item);
                        if(index && _index%3 == 0){
                            this.table_data.push(arr);
                            arr = [];
                        }else if(_index == len){
                            this.table_data.push(arr);
                        }
                    });
                    // console.log(this.table_data,'table_data')
                    this.table_page_total = Math.ceil(len/3);
                }

            }).catch((err) => {
            console.log(err)
            })
        },
        leftSwitchEvent(){
            let activeIndexNum = Number(this.activeIndex);
            if(activeIndexNum === 0){
                activeIndexNum = 0
            }else{
                activeIndexNum--;
            }
            this.activeIndex = String(activeIndexNum);
            this.$refs.carousel.setActiveItem(this.activeIndex)
        },
        rightSwitchEvent(){
            let activeIndexNum = Number(this.activeIndex);
            activeIndexNum++;
            if(activeIndexNum ===  this.table_data.length)return;
            this.activeIndex = String(activeIndexNum);
            this.$refs.carousel.setActiveItem(this.activeIndex)
        },
        alarm_detail(item){
            console.log('二级页面数据内容展示'+JSON.stringify(item))
            this.params ={id:item.id,remark:'大屏结束报警'}
            this.openFullScreen2()
            this.dialog_bottom_data(item);

        },
        alarm_box_detail(item){
             console.log('二级页面数据内容展示'+JSON.stringify(item))
            // var info_item = null
            // this.table_data.some(function(data){

            //     data.some(function(data1){
            //         if(data1.id == item.id) {
            //             info_item = data1
            //             console.log('找到了跳出去吧');
            //             return true;
            // 　　    }
            // 　　    console.log(data);
            //     })
            //     if(info_item!=null){
            //         return true
            //     }
            // });
            this.openFullScreen2()
            this.dialog_bottom_data(item);
           
        },
        
        openFullScreen2() {
                this.loading = this.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
        },
        //详情中间的内容
        dialog_device_data(item){

          this.$http.get (dataUrl.interfaceAddress.alarmbounced, {params: {id:item.id}}).then (res => {
                 if(res.data.code===0){
                   this.loading.close()
                    this.detail.right_chars_data = res.data.body.right;
                 }
            }).catch((err) => {
               this.loading.close()
                console.log(err)
                // reject(err)
            })
        },

        //详情最下面的条目内容
        dialog_bottom_data(item){
            
          this.detail.alarminfo = item;
          console.log('deviceid',item)
          this.$http.get (dataUrl.interfaceAddress.getDevdetails, {params: {deviceId:item.deviceId}}).then (res => {
                    if(res.data.code===0){
                        this.detail.infodata = {};
                        this.showDialog = true;
                        this.detail.infodata = res.data.body;
                        this.dialog_device_data(item);
                    } else {
                        let message=res.data.info;
                        this.$message.error(message);
                    }

          })
         .catch((err) => {
            console.log(err);
         });
        },
        //关闭二级页面
        closeDialog(){
             this.showDialog = false;
        },
        //二级页面的解除报警
        close_alarm(){
            console.log('数据内容解除报警-=--=-=-='+JSON.stringify(this.params))
            this.$http.put(dataUrl.interfaceAddress.clearAlarmTask, this.params).then(res => {
                if(res.data&&res.data.code==0){
                    let message=res.data.info;
                    this.$message({
                        message: message,
                        type: 'success'
                    });
                   this.getList();
                } else {
                    let message=res.data.description;
                    this.$message.error(message);
                }

            }).catch((err) => {
            console.log(err)
            })
            this.showDialog = false;
        }
    },
    components:{
        listCarousel,
        dialogItem
    },
}
</script>
<style lang="less" scoped>
    .alarm_list{
        // height: 160px;
        width: 50%;
        z-index: 10;
        
        .title{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-size: 20px;
            color: #f5c644;
            margin: 0 auto;
            text-align: center;
            .title-info{
                font-weight: bold;
                margin: 0 30px;
            }
            .left-arrow,.right-arrow{
                display: inline-block;
                height: 21px;
                width: 15px;
            }
            .left-arrow{
                // background:url(../../../static/img/icon/right-arrow.png) no-repeat;
                background:url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/right-arrow.png) no-repeat;
                background-size: 100% 100%;
            }
            .right-arrow{
                // background:url(../../../static/img/icon/left-arrow.png) no-repeat;
                background:url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/left-arrow.png) no-repeat;
                background-size: 100% 100%;
            }
        }
        .alarm-wrapper{
            display: flex;
            justify-content: space-between;
            align-items: center;
            // background:url(../../../static/img/list.png) no-repeat;
            background:url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/list.png) no-repeat;
            background-size: 100% 100%;
            margin: 0px 30px 0 30px;
            padding:10px 12px 0 10px; //大
            //  padding:10px 12px 0 33px;  //小
            height: 108px;
            line-height: 108px;
            clear: both;
            .left-info{
                font-size: 32px;
                color: #04e0f9;
                font-weight: bold;
                width: 100px;
                height: 100%;
                float: left;
                display: inline-block;
                margin-left: 10px;
                text-align: center;
            }
            .list-box{
                width: 70%;
                flex:1;
                height: 100px;
                margin-top: 26px;
                margin-left: 10px;  //小
                display: inline-block;
                .tip{
                    text-align: center;
                    font-size: 16px;
                    line-height: 75px;
                    color: #04e0f9;
                    // font-family: Medium;
                }
                .address ,.time ,.type, .opt{
                    cursor: pointer;
                    text-align: left; //xiao
                }
                .address{
                    display: inline-block;
                    width: 30%;
                    // width: 200px;
                    // width: 130px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    border-right: 1px dashed #44619d;
                }
                .time{
                    display: inline-block;
                    // width: 160px;
                    width: 25%;
                    // width: 120px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    border-right: 1px dashed #44619d;
                }
                .type{
                    display: inline-block;
                    // width: 140px;
                    width: 20%;
                    // width:100px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    border-right: 1px dashed #44619d;
                }
                .opt{
                    display: inline-block;
                    // width: 43px;
                    width: 20%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .list-item{
                    width: 100%;
                    height: 25px;
                    line-height: 25px;
                    font-size: 14px;
                    color: #fed200;
                    margin-left: 10px;

                    // p{
                    // display: inline-block;
                    // &>span{
                    //     width: 80px;
                    //     overflow: hidden;
                    //     text-overflow: ellipsis;
                    //     white-space: nowrap;
                    // }
                    // margin:0 10px;
                    // }
                }
                .item-alarm{
                    width: 100%;
                    height: 25px;
                    line-height: 25px;
                    font-size: 14px;
                    color:#e60621;
                }
            }
            .right-info{
                width: 100px;
                float: right;
                margin-top:30px;
                display: inline-block;
                .left-slide-arrow,.right-slide-arrow{
                    display: inline-block;
                    height: 36px;
                    width: 32px;
                    margin: 0 5px;
                    cursor: pointer;
                }
                .left-slide-arrow{
                    // background:url(../../../static/img/icon/left-slide-arrow.png) no-repeat;
                    background:url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/left-slide-arrow.png) no-repeat;
                    background-size: 100% 100%;
                }
                .right-slide-arrow{
                    // background:url(../../../static/img/icon/right-slide-arrow.png) no-repeat;
                    background:url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/icon/right-slide-arrow.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }

</style>
<style lang="less">
.alarm_list{
    .list-box{
        .el-carousel__container{
            height: 80px !important;
        }
    }

}

</style>





// WEBPACK FOOTER //
// src/page/main_content/alarm_list.vue